import axios from 'axios';

/**
 * Verifica se o erro recebido é um erro de autorização (`401`).
 */
function isAuthorizationError(error: unknown): boolean {
  return axios.isAxiosError(error) && error.response?.status === 401;
}

export default isAuthorizationError;
